export type DecodedQri = {
  domain: string;
  type: string;
  company_id: string;
  id: string;
  version_id?: string;
};

/**
 * Decodes a QRI into its reference object.
 *
 * A QRI is the base64url-encoding of the clear-string
 * `{domain}/{type}/{company_id}/{id}[/{version_id}]`, optionally prefixed with the
 * QRI service base URL (`{baseUrl}/{base64url}`). Because base64url never contains a
 * `/`, the encoded payload is always the final `/`-separated segment.
 *
 */
export const decodeQri = (qri: string): DecodedQri => {
  const encoded = qri.split('/').filter(Boolean).pop() ?? '';
  const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  const clearString = atob(padded);

  const [domain = '', type = '', company_id = '', id = '', version_id] = clearString.split('/');

  return { domain, type, company_id, id, ...(version_id ? { version_id } : {}) };
};
